fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = "blue";
fabric.Object.prototype.cornerStyle = "circle";

fabric.Group.prototype.setControlsVisibility({
  mtr: false,
  mr: false,
  ml: false,
  mt: false,
  mb: false,
});

fabric.Textbox.prototype.setControlsVisibility({
  mtr: false,
  mt: false,
  mb: false,
  tr: false,
  tl: false,
  bl: false,
  br: false,
});
